import { render, staticRenderFns } from "./SchoolAddEditTabInformation.vue?vue&type=template&id=1e8c06fe"
import script from "./SchoolAddEditTabInformation.vue?vue&type=script&lang=js"
export * from "./SchoolAddEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./SchoolAddEditTabInformation.vue?vue&type=style&index=0&id=1e8c06fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports